import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StepperQueries } from '../../../../../../core/store/stepper/stepper.queries';
import { OnboardingQueries } from '../../../../../../core/store/onboarding/onboarding.queries';
import { first, map, switchMap, takeWhile } from 'rxjs/operators';
import { Entity } from '../../../../../../core/models/entity.model';
import { EntityQueries } from '../../../../../../core/store/entity/entity.queries';
import { HttpService } from '../../../../../../core/services/http/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StepModel } from '../../../../../stepper/models/step.model';
import {
	ConfigQuestionType,
	REVIEW_STATUS,
} from '../../../../../../core/constants/enum.const';
import { ConfigQueries } from '../../../../../../core/store/config/config.queries';
import { ConfigUtil } from '../../../../../../core/utils/config.util';
import { ConfigQuestion } from '../../../../../../core/models/config-question.interface';
import { BaseDueDiligenceComponent } from '../../base-due-diligence.component';

@Component({
	selector: 'bcb-kyc-procedures',
	templateUrl: './kyc-procedures.component.html',
	styleUrls: ['./kyc-procedures.component.scss'],
})
export class KycProceduresComponent extends BaseDueDiligenceComponent {
	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}
}
